import { motion } from "framer-motion";
import {
  Wifi, Car, Sun, Eye, Wind, UtensilsCrossed, WashingMachine, Tv, Shirt,
  BedDouble, Bath, Users, Maximize, Building2, Sparkles, Check,
} from "lucide-react";

const ICONS = {
  "Wi-Fi": Wifi,
  "Estacionamento": Car,
  "Varanda": Sun,
  "Terraço amplo": Sun,
  "Vista desafogada": Eye,
  "Ventiladores": Wind,
  "Cozinha totalmente equipada": UtensilsCrossed,
  "Máquina de lavar roupa": WashingMachine,
  "Máquina de lavar louça": UtensilsCrossed,
  "TV": Tv,
  "Roupa de cama e toalhas": Shirt,
  "Elevador no prédio": Building2,
};

export const Amenities = ({ property }) => {
  const stats = [
    { icon: BedDouble, value: property?.bedrooms, label: "Quartos" },
    { icon: Bath, value: property?.bathrooms, label: "Casas de banho" },
    { icon: Users, value: property?.max_guests, label: "Hóspedes" },
    { icon: Maximize, value: `${property?.area_m2} m²`, label: "Área bruta" },
    { icon: Building2, value: property?.floor, label: "Com elevador" },
  ];

  return (
    <section id="comodidades" data-testid="amenities-section" className="bg-sand/60 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="mb-14 grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-5" data-testid="stats-row">
            {stats.map(({ icon: Icon, value, label }, i) => (
              <motion.div
                key={label}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                className="border-l-2 border-clay/60 pl-4"
                data-testid={`stat-${label.toLowerCase().replace(/\s/g, "-")}`}
              >
                <Icon size={18} className="mb-2 text-clay" />
                <p className="font-display text-2xl text-ink sm:text-3xl">{value}</p>
                <p className="text-xs uppercase tracking-[0.16em] text-fog">{label}</p>
              </motion.div>
            ))}
          </div>

          <div className="mb-10 flex items-center gap-3">
            <Sparkles size={18} className="text-clay" />
            <h2 className="font-display text-3xl text-ink sm:text-4xl">Comodidades</h2>
          </div>
          <div className="grid grid-cols-1 gap-x-10 gap-y-4 sm:grid-cols-2 lg:grid-cols-3">
            {(property?.amenities || []).map((item, i) => {
              const Icon = ICONS[item] || Check;
              return (
                <motion.div
                  key={item}
                  initial={{ opacity: 0, x: -16 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: (i % 6) * 0.06 }}
                  className="flex items-center gap-3 border-b border-line pb-4 text-base text-ink/85"
                  data-testid={`amenity-${i}`}
                >
                  <Icon size={18} className="shrink-0 text-clay" />
                  {item}
                </motion.div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
